import { defineStore } from 'pinia'
import Actions from './actions'
import Getters from './getters'
import { useState } from './state'

export { type FlexFlightState } from './state'

export const useFlexFlightStore = defineStore('flexFlight', {
  state: useState,
  actions: { ...Actions },
  getters: { ...Getters },
})

export type DetailsStoreContext = ReturnType<typeof useFlexFlightStore>